export const selectCompressionCandidates = ({
  selectedDocuments,
  sizeDocuments,
  replacements = [],
  outcomes = {},
  fallbackForFailure = false,
}) => {
  const uniqueDocuments = [...new Map(
    (selectedDocuments || []).map(document => [document.id, document])
  ).values()];
  const replacementByOriginal = replacements.reduce((result, replacement) => {
    result[replacement.originalDocumentId] = replacement.compressedDocumentId;
    return result;
  }, {});
  const sizesById = (sizeDocuments || []).reduce((result, document) => {
    result[document.documentId] = document;
    return result;
  }, {});

  const eligibleDocuments = uniqueDocuments
    .map(document => {
      const effectiveDocumentId = replacementByOriginal[document.id] || document.id;
      const size = sizesById[effectiveDocumentId];
      return size
        ? {
            ...size,
            documentId: document.id,
            effectiveDocumentId,
          }
        : null;
    })
    .filter(document => {
      if (!document?.isPdf) {
        return false;
      }
      const outcome = outcomes[document.documentId];
      return !['success', 'no-reduction', 'permanent-error'].includes(outcome?.status);
    });

  const largeDocuments = eligibleDocuments.filter(document => document.isLarge);
  if (!fallbackForFailure || largeDocuments.length > 0) {
    return largeDocuments;
  }

  return uniqueDocuments.length > 1 ? eligibleDocuments : [];
};
